import { useEffect, useState } from 'react';

/**
 * L'heure courante (en millisecondes), remise à jour toutes les `periodeMs`.
 *
 * Un camion qui cesse d'émettre n'envoie plus de message : sans horloge, son
 * « signal actif » resterait affiché jusqu'au prochain rafraîchissement de la
 * liste. Les écrans qui jugent la fraîcheur d'une position lisent cette heure.
 */
export default function useMaintenant(periodeMs = 30000) {
  const [maintenant, setMaintenant] = useState(() => Date.now());
  useEffect(() => {
    const minuteur = window.setInterval(() => setMaintenant(Date.now()), periodeMs);
    return () => window.clearInterval(minuteur);
  }, [periodeMs]);
  return maintenant;
}
